import React, { useContext, useEffect, useState } from "react";
import ServiceMasterSlider from "./ServiceMasterSlider";
import BaseMasterGrid from "../BaseMasterGrid";
import KendoLoader from "../../KendoLoader";
import axios from "axios";
import { BASE_URL, jobTypes } from "../../../constants";
import CustomerMaster from "../customer/CustomerMaster";
import AppContext from "../../../context/app-context";

const ServiceTemplateMaster = () => {
  const authCtx = useContext(AppContext);
  const [isAdmin, setIsAdmin] = useState(false);

  const defaultEntity = {
    name: "",
    jobType: null,
    customerId: null,
    originPortId: null,
    destPortId: null,
    logisticsServices: [],
    isActive: true,
  };
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [entities, setEntities] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [serviceTemplate, setServiceTemplate] = useState(defaultEntity);
  const [pageState, setPageState] = useState({
    take: 10,
    skip: 0,
    total: 0,
    logic: "and",
    filters: [
      {
        field: "name",
        operator: "contains",
        value: "",
      },
    ],
  });

  const gridColumns = [
    { field: "id", title: "ID", hidden: true },
    {
      field: "name",
      title: "Name",
      filterable: true,
      sortable: true,
      hidden: false,
      width:"150"
    },
    {
      field: "jobTypeLabel",
      title: "JobType",
      filterable: true,
      sortable: true,
    },
    {
      field: "customerName",
      title: "Customer",
      filterable: true,
      sortable: true,
    },
    {
      field: "originPortName",
      title: "Origin",
      filterable: true,
      sortable: true,
      
    
    },
    {
      field: "destPortName",
      title: "Destination",
      filterable: true,
      sortable: true,
    },
    {
      field: "isActive",
      title: "Status",
      filterable: false,
      sortable: true,
      isBoolean: true,
      width: "120",
    },
    {
      field: "createdUserName",
      title: "Created By",
      filterable: false,
      sortable: false,
      width: "150",
    },
    {
      field: "creationDate",
      title: "Created Date",
      filterable: false,
      sortable: true,
      isDate: true,
      width: "140",
    },
    {
      field: "modifiedUserName",
      title: "Edited By",
      filterable: false,
      sortable: false,
      width: "150",
    },
    {
      field: "modificationDate",
      title: "Edited Date",
      filterable: false,
      sortable: true,
      isDate: true,
      width: "140",
    },
  ];

  const onCreate = (item, id) => {
    const enriched = {
      ...item,
      id,
      customerName: customers.find((c) => c.id === item.customerId)?.name ?? item.customerName ?? null,
    };
    const updated = [...entities, enriched];
    setEntities(updated.sort((a, b) => (b.isActive === true) - (a.isActive === true)));
  };

  const onCreateClick = () => {
    setServiceTemplate(defaultEntity);
    setOpen(true);
  };

  const onEditClick = (e) => {
    if (!isAdmin) return;
    setServiceTemplate({
      ...e.dataItem,
      country: { code: e.dataItem.countryCode, name: e.dataItem.countryName },
    });
    setOpen(true);
  };

  const loadData = async (searchText, state, customerList) => {
    setLoading(true);
    const res = await axios.get(
      `${BASE_URL}/ServiceTemplate?searchText=${searchText}&skip=${state.skip}&take=${state.take}`
    );
    const cList = customerList || customers;
    const mapped = res.data.data.map((x) => ({
      ...x,
      jobTypeLabel: jobTypes.find((y) => y.id === x.jobType)?.name,
      customerName: cList.find((c) => c.id === x.customerId)?.name ?? x.customerName ?? null,
      isActive: x.isActive ?? true,
    }));
    setEntities(mapped.sort((a, b) => (b.isActive === true) - (a.isActive === true)));
    setPageState((pre) => ({
      ...pre,
      total: res.data.totalCount,
      skip: res.data.pageNo,
      take: res.data.pageSize,
      value: searchText,
    }));
    setLoading(false);
  };

  const onGridFilter = (e) => {
    let searchText = "";
    if (e.filter && e.filter.filters && e.filter.filters[0].value !== "") {
      searchText = e.filter.filters[0].value;
    } else {
      searchText = "~ALL";
    }
    const state = {
      ...pageState,
      filter: { ...e.filter },
      skip: 0,
      value: searchText,
    };
    setPageState(state);
    loadData(searchText, state);
  };

  const onUpdate = (item) => {
    const enriched = {
      ...item,
      customerName: customers.find((c) => c.id === item.customerId)?.name ?? item.customerName ?? null,
    };
    const updated = entities.map((c) => (c.id === item.id ? enriched : c));
    setEntities(updated.sort((a, b) => (b.isActive === true) - (a.isActive === true)));
  };

  useEffect(() => {
    const init = async () => {
      const searchText = "~ALL";
      const cusRes = await axios.get(`${BASE_URL}/Lookup/Customers?searchText=~ALL`).catch(() => ({ data: [] }));
      const cList = cusRes.data || [];
      setCustomers(cList);
      loadData(searchText, pageState, cList);

      const userId = authCtx.profile?.ID || authCtx.profile?.id;
      if (userId) {
        axios.get(`${BASE_URL}/UserAccount/${userId}`).then((res) => {
          const role = res.data.role ?? res.data.Role;
          setIsAdmin(role === 200 || role === 500 || role === "Admin" || role === "SuperAdmin");
        }).catch(() => {});
      }
    };
    init();
  }, []);

  return (
    <div className="px-4 py-4 sm:px-6 lg:px-8">
      <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          Tariff
        </h3>
        {isAdmin && (
          <div className="mt-3 flex sm:mt-0 sm:ml-4">
            <button
              type="button"
              className="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              onClick={onCreateClick}
            >
              Create
            </button>
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow relative overflow-hidden sm:rounded-lg">
              {loading && <KendoLoader />}
              <BaseMasterGrid
                data={entities}
                columns={gridColumns}
                config={{
                  state: {
                    skip: 0,
                    take: pageState.take,
                    sort: [{ field: "isActive", dir: "desc" }, { field: "name", dir: "asc" }],
                  },
                  pageable: true,
                  filterable: true,
                  sortable: true,
                }}
                onEditClick={onEditClick}
                setPageState={setPageState}
                loadData={loadData}
                pageState={pageState}
                onGridFilter={onGridFilter}
              ></BaseMasterGrid>
            </div>
          </div>
        </div>
      </div>
      <ServiceMasterSlider
        open={open}
        setOpen={setOpen}
        serviceTemplate={serviceTemplate}
        setServiceTemplate={setServiceTemplate}
        onUpdate={onUpdate}
        onCreate={onCreate}
      />
    </div>
  );
};

export default ServiceTemplateMaster;
